module.exports = __webpack_public_path__ + "img/mobile-app.c2b1747b.png";